import { useInfiniteQuery, useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import { RequestPurchasesQuery } from './RequestPurchase.types';

import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import {
  getRequestPurchase,
  listRequestPurchases,
} from './RequestPurchase.service';

export const QUERY_ID = 'request-purchases';

export function useListRequestPurchases(
  params?: RequestPurchasesQuery,
  enabled?: boolean,
) {
  const query = useInfiniteQuery(
    [QUERY_ID, { ...params, enabled }],
    ({ pageParam }) => {
      const req: RequestPurchasesQuery = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listRequestPurchases(req);
    },
    {
      enabled,
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useRequestPurchaseDetail(requestPurchaseId?: number) {
  const query = useQuery(
    ['request-purchase-detail', requestPurchaseId],
    () => getRequestPurchase(requestPurchaseId),
    { enabled: !!requestPurchaseId },
  );

  useServiceError(query.error);

  return query;
}
